import { Typography, Switch, IconButton, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { Column, Intake } from "src/api/types";
import { format } from "date-fns";
import { useUpdateIntakeMutation } from "src/api/services/intakesApi";
import { useCallback } from "react";
import HoverReveal from "src/components/HoverReveal";
import { Edit } from "@mui/icons-material";
import { theme } from "src/assets/theme";
import { useIntakeDrawer } from "src/context/drawers/IntakesDrawerProvider/useIntakesDrawer";

export const useColumns = (): Column<Intake>[] => {
  const [updateIntake] = useUpdateIntakeMutation();
  const { handleOpenUpdateIntake } = useIntakeDrawer();

  const handleToggleActive = useCallback(
    (row: Intake) => {
      updateIntake({
        id: row.id,
        product_slug: row.product.slug,
        body: { active: !row.active },
      });
    },
    [updateIntake],
  );

  return [
    {
      id: "edit",
      label: "Edit",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => (
        <IconButton onClick={() => handleOpenUpdateIntake(row)}>
          <Edit sx={{ color: theme.palette.secondary.main }} />
        </IconButton>
      ),
    },
    {
      id: "active",
      label: "Active",
      minWidth: 120,
      align: "center",
      orderable: false,
      format: (row) => row.active.toString(),
      render: (row) => (
        <Switch
          color="secondary"
          checked={row.active}
          onChange={() => handleToggleActive(row)}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
      minWidth: 50,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => <Link to={`${row.id}/questions`}>{row.id}</Link>,
    },
    {
      id: "type",
      label: "Type",
      minWidth: 200,
      align: "center",
      orderable: false,
      format: (row) => row.visit_type,
      render: (row) => (
        <Typography textTransform="capitalize">{row.visit_type}</Typography>
      ),
    },
    {
      id: "created_at",
      label: "Created",
      minWidth: 200,
      align: "center",
      orderable: false,
      format: (row) => row.visit_type,
      render: (row) => {
        const createdAt =
          row.created_at == null
            ? "N/A"
            : format(new Date(row.created_at), "MM/dd/yyyy");
        return <Typography>{createdAt}</Typography>;
      },
    },
    {
      id: "first_question",
      label: "First question",
      minWidth: 200,
      align: "center",
      orderable: false,
      format: (row) => row.first_question.title ?? "N/A",
      render: (row) => (
        <HoverReveal
          label={row.first_question.slug}
          value={row.first_question.title}
        />
      ),
    },
    {
      id: "build",
      label: "Continue build",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => {
        if (row.active) {
          return;
        }

        return (
          <Link to={`${row.id}/builder`}>
            <Button>Build</Button>
          </Link>
        );
      },
    },
  ];
};
